import { Global } from 'types/global.type';

export default (global as Global);
